import { Component, Input, ElementRef, ViewChild, OnChanges } from '@angular/core';
import { LatLngBounds } from '@agm/core';
import { ObraDTO } from 'src/app/models/dtos/obra-dto';
import { take, concatMap } from 'rxjs/operators';
import { CapaService } from 'src/app/services/capa.service';
import { from, Subscription } from 'rxjs';
import { Capa } from 'src/app/models/entities/capa';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { SegmentoService } from 'src/app/services/segmento.service';
import { Segmento } from 'src/app/models/entities/segmento';
declare const google: any;

@Component({
  selector: 'formato-pdf-nota-informativa',
  templateUrl: './formato-pdf-nota-informativa.component.html',
  styleUrls: ['./formato-pdf-nota-informativa.component.scss']
})
export class FormatoPdfNotaInformativaComponent implements OnChanges {

  @ViewChild('formatoHtmlPDF')
  public formatoHtmlPDF: ElementRef;

  @Input('obraSeleccionada')
  public obraSeleccionada: ObraDTO;
  public elementosObra: Segmento[] = [];
  
  public primerEjercicioFiscal: any;
  public existePrimero: boolean = false;
  public segundoEjercicioFiscal: any;
  public existeSegundo: boolean = false;
  public tercerEjercicioFiscal: any;
  public existeTercero: boolean = false;

  public map: any;
  public marcadorInicial: any;
  public marcadorFinal: any;

  public latActual: any;
  public lngActual: any;
  public zoomActual: any;

  public fechaActual: any;
  public TIPO_OBRA_PROCESO: string = '0';
  public colores: ElementoCatalogo[] = [];
  public datosCoordenadas: any;
  public colorCapa: any;
  public suscripcionColores: Subscription;

  constructor(
    private segmentoService: SegmentoService,
    private capaService: CapaService,
    private catalogoService: CatalogoService
  ) { }

  public ngOnChanges(): void {
    const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    let fechaConvert: Date = new Date(this.obraSeleccionada.obra.fechaActualizacion);
    this.fechaActual = (fechaConvert.getUTCDate() + " de " + monthNames[fechaConvert.getUTCMonth()] + " de " + fechaConvert.getUTCFullYear());
    let contadorEjercicios: number = this.obraSeleccionada.obra.ejerciciosFiscales.length;
    if(contadorEjercicios > 0){
      this.primerEjercicioFiscal = this.obraSeleccionada.obra.ejerciciosFiscales[0];
      this.existePrimero = true;
    }
    if (contadorEjercicios > 1) {
      this.segundoEjercicioFiscal = this.obraSeleccionada.obra.ejerciciosFiscales[1];
      this.existeSegundo = true;
    }
    if (contadorEjercicios > 2) {
      this.tercerEjercicioFiscal = this.obraSeleccionada.obra.ejerciciosFiscales[2];
      this.existeTercero = true;
    }
    this.obtenerCatalogos();
    this.obtenerCoordenadas();
  }

  public obtenerCatalogos(): void {
    this.suscripcionColores = this.catalogoService.obtenerCatalogo<ElementoCatalogo>(RutaCatalogoEnum.COLORES).pipe(take(1)).subscribe(
      (colores: ElementoCatalogo[]) => this.colores = colores
    );
  }

  public async obtenerCoordenadas() {
    this.elementosObra = await this.capaService.findByKeyLevantamientoObra(this.obraSeleccionada.obra.keyLevantamientoObra).pipe(
      take(1),
      concatMap((capas: Capa[]) => from(capas).pipe(
        concatMap((capa: Capa) => this.segmentoService.findByKeyCapa(capa.key).pipe(take(1))
        ))
      ),
      take(1)
    ).toPromise();
    this.datosCoordenadas = this.elementosObra[0].coordenadas;
    this.obtenerMarcadorInicial();
    this.obtenerMarcadorFinal();
  }

  public obtenerMarcadorInicial(): void {
    this.marcadorInicial = {
      lat: this.elementosObra[0].coordenadas[this.elementosObra[0].coordenadas.length - 1].latitud,
      lng: this.elementosObra[0].coordenadas[this.elementosObra[0].coordenadas.length - 1].longitud
    };
  }

  public obtenerMarcadorFinal(): void {
    this.marcadorFinal = {
      lat: this.elementosObra[0].coordenadas[0].latitud,
      lng: this.elementosObra[0].coordenadas[0].longitud
    };
  }

  public mapReady(event: any): void {
    this.map = event;
      this.centrarPolyline();
  }

  public centrarPolyline(): void {
    const bounds: LatLngBounds = new google.maps.LatLngBounds();
    for (const elementoObra of this.datosCoordenadas) {
      bounds.extend(new google.maps.LatLng(elementoObra.latitud, elementoObra.longitud));
    }
    this.map.fitBounds(bounds);
  }

  public cambioZoom(event: any): void {
    this.zoomActual = event;
  }

  public cambioCentro(event: any): void {
    this.latActual = event.lat;
    this.lngActual = event.lng;
  }

  public ngOnDestroy(): void {
    if (this.suscripcionColores) {
      this.suscripcionColores.unsubscribe();
    }
  }

}